module.exports = (require("./helpers/browser/js-loader")(parcelRequire.resolve("knggI"))).then(() => parcelRequire('8yz4j'));